/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PracticeAreaEnum {
  CorporateAndCommercial = "CorporateAndCommercial",
  DataPrivacyAndCybersecurity = "DataPrivacyAndCybersecurity",
  Energy = "Energy",
  Finance = "Finance",
  HealthcareAndLifeSciences = "HealthcareAndLifeSciences",
  IntellectualProperty = "IntellectualProperty",
  LaborAndEmployment = "LaborAndEmployment",
  LitigationAndDisputeResolution = "LitigationAndDisputeResolution",
  MergersAndAcquisitions = "MergersAndAcquisitions",
  RealEstate = "RealEstate",
  RegulatoryAndCompliance = "RegulatoryAndCompliance",
  Tax = "Tax",
  Technology = "Technology",
}

export const PracticeAreaEnumDisplay: Record<PracticeAreaEnum, string> = {
  [PracticeAreaEnum.CorporateAndCommercial]: "Corporate & Commercial",
  [PracticeAreaEnum.DataPrivacyAndCybersecurity]: "Data Privacy & Cybersecurity",
  [PracticeAreaEnum.Energy]: "Energy",
  [PracticeAreaEnum.Finance]: "Finance",
  [PracticeAreaEnum.HealthcareAndLifeSciences]: "Healthcare & Life Sciences",
  [PracticeAreaEnum.IntellectualProperty]: "Intellectual Property",
  [PracticeAreaEnum.LaborAndEmployment]: "Labor & Employment",
  [PracticeAreaEnum.LitigationAndDisputeResolution]: "Litigation & Dispute Resolution",
  [PracticeAreaEnum.MergersAndAcquisitions]: "Mergers & Acquisitions",
  [PracticeAreaEnum.RealEstate]: "Real Estate",
  [PracticeAreaEnum.RegulatoryAndCompliance]: "Regulatory & Compliance",
  [PracticeAreaEnum.Tax]: "Tax",
  [PracticeAreaEnum.Technology]: "Technology",
};
